export default __webpack_public_path__ + "static/media/main-top-sp.60bf75c8.png";